export default __webpack_public_path__ + "static/media/adresse.a40b86e0.svg";